import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateRange } from '../../models/date-range';

@Component({
  selector: 'lib-timepicker',
  templateUrl: './timepicker.component.html',
  styleUrls: ['./timepicker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TimepickerComponent),
      multi: true
    }
  ],
  standalone: false
})
export class TimepickerComponent implements ControlValueAccessor {
  writeValue(obj: any): void {
    if (obj != null && obj != this.selectedTime) {
      this.selectedTime = this.times.find(x => x.value == obj)?.value;
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public onChange = (_: DateRange) => {};
  public onTouched = () => {};

  public disabled = false;

  @Input()
  public increments: 'qtr' | 'half';
  @Input()
  public extraClasses: string = '';
  public times: TimeOption[] = [];

  public selectedTime: string | null = null;

  constructor() {
    const hours = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    let minutes = [];
    if (this.increments == 'qtr') {
      minutes = ['00', '15', '30', '45'];
    } else {
      minutes = ['00', '30'];
    }
    hours.forEach(hour => {
      minutes.forEach(minute => {
        this.times.push({
          display: `${hour}:${minute} AM`,
          value: `${hour}:${minute}`
        });
      });
    });
    hours.forEach(hour => {
      minutes.forEach(minute => {
        let hourVal = hour;
        if (hourVal < 12) {
          hourVal = hourVal + 12;
        }
        this.times.push({
          display: `${hour}:${minute} PM`,
          value: `${hourVal}:${minute}`
        });
      });
    });
  }

  valueChanged(event: any) {
    this.onChange(event);
    this.onTouched();
  }
}

export interface TimeOption {
  display: string;
  value: string;
}
